 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_cover'
 import HTMLEBB from '@/components/html/ebb'
 import HTMLAD1 from '@/components/html/ad1'
 import HTMLAD2 from '@/components/html/ad2'
 import HTMLTLU from '@/components/html/tlu'
 import HTMLMM from '@/components/html/mm'
 import HTMLALST from '@/components/html/alst'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML04_TP from '@/components/html/04_tp'
 import HTML16_DEDI from '@/components/html/16_dedi'
 import HTML05_TOC from '@/components/html/05_toc'
 import HTML06_C1 from '@/components/html/06_c1'
 import HTML07_C2 from '@/components/html/07_c2'
 import HTML08_C3 from '@/components/html/08_c3'
 import HTML09_C4 from '@/components/html/09_c4'
 import HTML10_C5 from '@/components/html/10_c5'
 import HTML11_C6 from '@/components/html/11_c6'
 import HTML12_C7 from '@/components/html/12_c7'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML18_CR from '@/components/html/18_cr'
 import HTMLAUBA from '@/components/html/auba'
 import HTMLORIMAD from '@/components/html/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/00_cover",
 			"name" : "html/00_cover",
 			"component" : HTML00_COVER
 		},
 		{
 			"path" : "/html/ebb",
 			"name" : "html/ebb",
 			"component" : HTMLEBB
 		},
 		{
 			"path" : "/html/ad1",
 			"name" : "html/ad1",
 			"component" : HTMLAD1
 		},
 		{
 			"path" : "/html/ad2",
 			"name" : "html/ad2",
 			"component" : HTMLAD2
 		},
 		{
 			"path" : "/html/tlu",
 			"name" : "html/tlu",
 			"component" : HTMLTLU
 		},
 		{
 			"path" : "/html/mm",
 			"name" : "html/mm",
 			"component" : HTMLMM
 		},
 		{
 			"path" : "/html/alst",
 			"name" : "html/alst",
 			"component" : HTMLALST
 		},
 		{
 			"path" : "/html/love_1",
 			"name" : "html/love_1",
 			"component" : HTMLLOVE_1
 		},
 		{
 			"path" : "/html/04_tp",
 			"name" : "html/04_tp",
 			"component" : HTML04_TP
 		},
 		{
 			"path" : "/html/16_dedi",
 			"name" : "html/16_dedi",
 			"component" : HTML16_DEDI
 		},
 		{
 			"path" : "/html/05_toc",
 			"name" : "html/05_toc",
 			"component" : HTML05_TOC
 		},
 		{
 			"path" : "/html/06_c1",
 			"name" : "html/06_c1",
 			"component" : HTML06_C1
 		},
 		{
 			"path" : "/html/07_c2",
 			"name" : "html/07_c2",
 			"component" : HTML07_C2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js